import dayjs from 'dayjs';

/**
 * 쿠폰 만료일을 사용자 친화적인 텍스트로 변환
 * @param expirationDate - 만료일 문자열 (YYYY-MM-DD 형식)
 * @returns 만료 텍스트 ("오늘 만료" | "만료 N일 전" | "YYYY.MM.DD까지")
 */
export const getCouponExpirationText = (expirationDate: string): string => {
  const today = dayjs().startOf('day');
  const expireDate = dayjs(expirationDate).startOf('day');
  const daysLeft = expireDate.diff(today, 'day');

  if (daysLeft === 0) {
    return '오늘 만료';
  }

  if (daysLeft >= 1 && daysLeft <= 7) {
    return `만료 ${daysLeft}일 전`;
  }

  return `${expireDate.format('YYYY.MM.DD')}까지`;
};
